import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';

export interface CheckoutJson {
  checkout_url: string;
  entity_id: string;
  checkout_id: string;
  completed: boolean;
}

export interface PaymentCard {
  card: PaymentCardDetail;
  registrationId: string;
}

export interface PaymentCardDetail {
  bin: string;
  expiryMonth: string;
  expiryYear: string;
  holder: string;
  last4Digits: string;
}
@Injectable({
  providedIn: 'root',
})
export class PeachpayService {
  constructor(private readonly http: HttpClient) {}

  getEmbeddedUrl$(uuid: string, userID: number): Observable<CheckoutJson> {
    return this.http.get<CheckoutJson>(`/api/peachpay`, { params: { uuid, userID } }).pipe(
      catchError((err: unknown) => {
        console.error('Error fetching PeachPay URL:', err);
        return of({ checkout_url: '', entity_id: '', checkout_id: '', completed: false });
      }),
    );
  }

  getPaymentsCards$(userID: number): Observable<PaymentCard[]> {
    return this.http.get<PaymentCard[]>(`/api/payments/card`, { params: { userID }, observe: 'response' }).pipe(
      catchError((err: unknown) => {
        console.error('Error fetching card tokens:', err);
        return of([]);
      }),
      map((response: HttpResponse<PaymentCard[]>) => {
        if (!response.body) {
          throw new Error('No response body from PeachPay API');
        }
        return response.body;
      }),
    );
  }

  postPaymentsCards$(userID: number, card: PaymentCard): Observable<boolean> {
    return this.http.post<boolean>(`/api/payments/card`, card, { params: { userID }, observe: 'response' }).pipe(
      catchError((err: unknown) => {
        console.error('Error fetching PeachPay URL:', err);
        return of(null);
      }),
      map((response: HttpResponse<boolean>) => {
        if (!response?.body) {
          throw new Error('No response body from PeachPay API');
        }
        return response.body;
      }),
    );
  }

  deletePaymentsCards$(userID: number, registrationId: string): Observable<boolean> {
    return this.http.delete<boolean>(`/api/payments/card`, { params: { userID, registrationId }, observe: 'response' }).pipe(
      catchError((err: unknown) => {
        console.error('Error fetching PeachPay URL:', err);
        return of(null);
      }),
      map((response: HttpResponse<boolean>) => {
        if (!response.body) {
          throw new Error('No response body from PeachPay API');
        }
        return response.body;
      }),
    );
  }
}
